<template>
  <div class="SalaryPaymentField">
    <div class="label">{{ label }}</div>
    <div class="value" @click="showDatePicker = true">
      <div v-if="SalaryPaymentField">{{ SalaryPaymentField }}</div>
      <div v-else style="color: rgba(51, 51, 51, 0.4)">请选择</div>
      <img class="oride-icon" src="@/assets/style/oride-icon.png" alt="" />
    </div>
    <van-popup v-model="showDatePicker" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        @confirm="onConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { formatDate } from "@/common/index.js";
export default {
  name: "SalaryPaymentField",
  components: {},
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      SalaryPaymentField: "",
      showDatePicker: false,
      currentDate: new Date(),
    };
  },
  async mounted() {},
  methods: {
    onConfirm() {
      this.SalaryPaymentField = formatDate(this.currentDate);
      this.$emit("input", this.SalaryPaymentField);
      this.showDatePicker = false;
    },
  },
  watch: {
    value(newVal) {
      this.currentDate = new Date(newVal);
      this.SalaryPaymentField = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
.SalaryPaymentField {
  padding: 10px;
  font-size: 14px;
  color: #333333;
  background: #ebebeb;
  border-radius: 27px;
  margin-top: 16px;
  display: flex;
  align-items: center;
}
.label {
  font-size: 14px;
  color: #777777;
  width: 70px;
}
.value {
  flex: 1;
  display: flex;
  align-items: center;
  border-radius: 17px;
  justify-content: space-between;
  font-size: 14px;
  .oride-icon {
    height: 20px;
    margin-left: 10px;
  }
}
</style>
